// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1S3b5","button--secondary":"Button_button--secondary__1IsmU"};